<template>
  <div>
    <h2 class="my-5">
      <b>Enter the URL of the webpage to capture and sign</b>
    </h2>
    <div class="row px-3 ">
      <div class="secure-indicator">
        <img v-if="!isURLSecure" width="22px" src="../assets/images/unlock.svg" />
        <img v-else width="25px" src="../assets/images/safe.svg" />
      </div>
      <input type="url" class="form-control" placeholder="https://www.example.com" @input="validateInput" />
    </div>
    <br />
    <vue-recaptcha :sitekey="recaptchaKey" @verify="onVerify" @expired="onExpired"></vue-recaptcha>
    <div class="d-flex pt-5 steps-button">
      <button class="btn back-btn ml-0 mr-auto" @click="nextHandler(0)">
        <i class="fa fa-angle-left mr-2" /> Back
      </button>
      <button class="btn next-btn ml-auto mr-0" @click="customNextHandler"
        :disabled="!isStepComplete || !recaptchaSuccess">
        Next <i class="fa fa-angle-right ml-2" />
      </button>
    </div>
  </div>
</template>
<script>
import validateURL from "../functions/validateURL"
import config from "../config"
import { VueRecaptcha } from 'vue-recaptcha'
export default {
  name: "WebCaptureSelection",
  components: { VueRecaptcha },
  props: {
    nextHandler: Function,
    webCapSelectionCB: Function,
  },
  data() {
    return {
      isStepComplete: false,
      isURLSecure: false,
      url: "",
      recaptchaKey: config.recaptchaKey,
      recaptchaSuccess: false,
      recaptchaResponse: ""
    }
  },
  methods: {
    validateInput(e) {
      var input = e.target.value
      if (!input.startsWith("http://") && !input.startsWith("https://")) {
        input = "https://" + input
      }
      this.isURLSecure = input.startsWith("https://")
      if (validateURL(input)) {
        this.url = input
        this.isStepComplete = true
        localStorage.removeItem('OTUbackup')
      } else {
        this.isStepComplete = false
      }
    },
    customNextHandler: function () {
      this.webCapSelectionCB({ url: this.url, captchaResponse: this.recaptchaResponse })
      this.nextHandler(2)
    },
    onVerify: function (response) {
      this.recaptchaResponse = response
      this.recaptchaSuccess = true
    },
    onExpired: function () {
      this.recaptchaSuccess = false
    }
  },
}
</script>
<style scoped>
input {
  height: 50px;
  line-height: 50px;
  border-radius: 10px;
  padding-left: 60px;
}

input:focus,
input:active {
  border-color: var(--border-color);
  outline: none !important;
  border: 1px solid var(--border-color);
}

.secure-indicator {
  width: 50px;
  height: 50px;
  margin-right: -50px;
  display: inline-block;
  z-index: 3;
  background: rgb(255, 255, 255);
  border-radius: 10px 0 0 10px;
  border: 1px solid var(--border-color);
  text-align: center;
  line-height: 50px;
}
</style>


// WEBPACK FOOTER //
// src/components/WebCaptureSelection.vue